let mockDepartments = [
  { id: 1, code: 1, nameEn: 'Product Revamp', nameAr: 'تجديد المنتج', employeeQty: 36 , shiftName:"Shift 20250827-1" , startDate:"03-09-2025" , endDate:"06-09-2025" },
  { id: 2, code: 2, nameEn: 'Solutions Team', nameAr: 'فريق الحلول' , employeeQty: 45 , shiftName:"Shift 20250827-2" , startDate:"03-09-2025" , endDate:"08-09-2025"},
  { id: 3, code: 3, nameEn: 'Sales Department', nameAr: 'قسم المبيعات   ' , employeeQty: 37 , shiftName:"Shift 20250827-3" , startDate:"03-09-2025" , endDate:"12-09-2025"},
  { id: 4, code: 4, nameEn: 'Support Department', nameAr:'قسم الدعم' , employeeQty: 16, shiftName:"Shift 20250827-4" , startDate:"03-09-2025" , endDate:"21-09-2025"},
];
let deptIdCounter = mockDepartments.length + 1;

const DepartmentAPI = {
  getAll: async () =>
    new Promise((resolve) => {
      setTimeout(() => resolve({ data: { data: [...mockDepartments] } }), 300);
    }),

  add: async (newData) =>
    new Promise((resolve) => {
      setTimeout(() => {
        const newItem = { ...newData, id: deptIdCounter++ };
        mockDepartments = [...mockDepartments, newItem];
        resolve({ data: { data: newItem } });
      }, 300);
    }),

  update: async (id, updatedData) =>
    new Promise((resolve) => {
      setTimeout(() => {
        const idx = mockDepartments.findIndex((d) => d.id === id);
        if (idx !== -1) {
          mockDepartments[idx] = { ...mockDepartments[idx], ...updatedData };
        }
        resolve({ data: { data: mockDepartments[idx] } });
      }, 300);
    }),

  delete: async (ids) =>
    new Promise((resolve) => {
      setTimeout(() => {
        const idsArr = Array.isArray(ids) ? ids : [ids];
        mockDepartments = mockDepartments.filter((d) => !idsArr.includes(d.id));
        resolve({ status: 200, data: { deletedIds: idsArr } });
      }, 300);
    }),
};

export default DepartmentAPI;
